import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { User } from 'src/app/models/user';
import { LoginService } from 'src/app/services/login.service';
import { VideoService } from 'src/app/services/video.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-screenrecord',
    templateUrl: './screenrecord.component.html',
    styleUrls: ['./screenrecord.component.css'],
    standalone: true,
    imports: [TranslateModule, CommonModule, FormsModule]
})
export class ScreenrecordComponent implements OnInit ,OnDestroy {
  isPauseButtonDisabled: boolean = true;
  isPaused = false; // State to track pause or resume
  // private videoUrl:any=environment.vidioUrl
  private videoSubscription: Subscription;

  private baseUrl: any = environment.baseUrl;
  private baseUrlStorage: any = environment.baseUrlStorage;
  alertMessage:any
  @ViewChild('alerttemplate') alerttemplate!: TemplateRef<any>;
  @ViewChild('delete_all_vidioes') DeleteAll: TemplateRef<any>
  @ViewChild('delete_all_vidioes_backup') DeleteAllBackup: TemplateRef<any>
  @ViewChild('downloadAllVidioes') downloadAll: TemplateRef<any>
  @ViewChild('downloadAllBkp') downloadAllBackupVidio: TemplateRef<any>


  @ViewChild('start_session') StartRecordTemplate: TemplateRef<any>
  @ViewChild('stop_session') StopRecordTemplate: TemplateRef<any>
  editMode: boolean[] = []; // Array to track edit mode state
  modalRef!: MatDialogRef<any>;
  @Input() device: any;
  @Output() booleanValueEmitter = new EventEmitter<boolean>();
  isScreenrecord: Boolean = true;
  isDraft: Boolean = false
  StopRecordbutton:Boolean=true
  videoRecords: any[] = [];
  ShowBackupScreenrecord: boolean = false;
  iconClass: string = 'fa fa-play-circle';
  screenrecord: any[] = [];
  currentUser: User = new User();
  newArray: any[] = [];
  isButtonDisabled: boolean = false; // Button is enabled by default
  msg: string = "";

  isBackupDisabled: boolean[] = [];


  constructor(private videoService: VideoService, private dialog: MatDialog, private loginService: LoginService) {

  }

  ngOnInit(): void {
    this.videoService.clearVideoRecords();
    this.videoRecords=[]
    window.onbeforeunload=null;
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
    this.videoSubscription =this.videoService.videoRecords$.subscribe((videoRecords) => {
      this.videoRecords = videoRecords;
    })
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(()=>{
      this.modalRef.close();;
      this.msg="";
    },2000)
  }
  StartRecord() {
    this.modalRef = this.dialog.open(this.StartRecordTemplate);
  }
  
  StartRecordConfirm() {

    this.videoRecords =[]
    
    this.videoService.updateBoolean(true)
    this.isScreenrecord = true
    this.isDraft = false
    this.modalRef.close()
    this.iconClass = 'fa fa-circle text-danger'; // Change to circle icon and red color
    const button = document.getElementById('Start');
    if (button) {
      button.classList.add('blink'); // Add the blink class
      this.isButtonDisabled = true;
      this.StopRecordbutton =false;
      this.isPauseButtonDisabled = false;
    }
  }

  // PauseRecord() {
  //   this.isScreenrecord = true
  //   this.isDraft = false
  // }

  StopRecord() {
    this.modalRef = this.dialog.open(this.StopRecordTemplate);
    setTimeout(()=>{
      this.modalRef.close();;
    },2000)
    this.videoService.updateBoolean(false)
    this.isScreenrecord = true
    this.isDraft = false
    const button = document.getElementById('Start');
    if (button) {
      button.classList.remove('blink'); // Remove the blink class after 2 seconds
      this.iconClass = 'fa fa-play-circle'
      this.isButtonDisabled = false;
      this.StopRecordbutton =true;
      this.isPauseButtonDisabled = true;
      this.isPaused = false;


    }
  }
  // async DownloadscreenRecord(url: string, recorderName: string) {
  //   const blob = await fetch(url).then(res => res.blob());
  //   const tempUrl = URL.createObjectURL(blob);
  
  //   const a = document.createElement('a');
  //   a.href = tempUrl;
  //   a.download = recorderName;
  //   a.click();
  
  //   URL.revokeObjectURL(tempUrl);  // safe — does NOT affect original URL
  // }  
  DownloadscreenRecord(url: string, recorderName: string) {

    const a = document.createElement('a');
    a.href = url;
    // if(recorderName == 'null' || 'undefined'){
    a.download = recorderName;

    // }

    a.click();
    // URL.revokeObjectURL(url);
  }
  DownloadAll() {
    this.modalRef = this.dialog.open(this.downloadAll)
  }

  DownloadAllscreenRecord() {
    this.videoRecords.forEach((vidio) => {
      const a = document.createElement('a');
      a.href = vidio.url;
      a.download = vidio.recorderName
      a.click();
      // URL.revokeObjectURL(vidio.url);
    })
    this.cancelRequest()
  }

  extractFilePath = (urlString: string): string => {
    try {
        // Add 'http:' prefix if needed to make it a valid URL
        const fullUrl = urlString.startsWith('http') ? urlString : `http:${urlString}`;
        const urlObj = new URL(fullUrl);
        return urlObj.searchParams.get('filePath') || '';
    } catch (e) {
        console.error("Error parsing URL:", e);
        return '';
    }
  };

  removeDraftScreenRecord(index: number) {
    let videoNameArrayy = this.newArray[index];
    let videoName = this.extractFilePath(videoNameArrayy);
    this.newArray.splice(index, 1);


    this.videoService.removeDraftScreenRecord(this.currentUser.email, videoName);
  }
  DeleteAllVidioesBackup() {
    this.modalRef = this.dialog.open(this.DeleteAllBackup)

  }
  draftClearRecord() {
    this.cancelRequest()
    this.videoService.removeDraftScreenRecordAll(this.currentUser.email);
    this.newArray = []
  }
  DraftSection() {
    this.isScreenrecord = false
    this.isDraft = true
  }
  async BackupScreenrecord() {

    //directly call  api ts don`t change
    {
      try {
        const response = await fetch(this.baseUrlStorage + '/file/files/ProteanStorageVideo', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          mode: 'cors'
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const list = await response.json();  // Wait for the JSON response to be parsed
        // Handle the response data here
        for (let i = 0; i < list.length; i++) {
          let fileName = list[i];          
          let url = this.baseUrlStorage + '/file/latestFile?bucket=ProteanStorageVideo&filePath='+fileName;
          if (!this.newArray.includes(url)) {
            this.newArray.push(url);
          } else {
          }

        }
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error); // Handle any errors
      }
    }

    this.ShowBackupScreenrecord = true
  }

  cancelRequest() {
    this.modalRef.close()
  }

  Ok() {
    this.modalRef.close()
  }

  showScreenrecordtab() {
    this.isScreenrecord = true
    this.isDraft = false
  }

  showScreenshotDrafttab() {
    this.isScreenrecord = false
    this.isDraft = true
  }

  DeleteAllVidioes() {
    this.modalRef = this.dialog.open(this.DeleteAll);

  }
  removeAllScreenRecord() {
    this.cancelRequest()
    this.videoRecords = []
    this.videoService.clearVideoRecords();
  }

  saveName(index: number): void {
    this.editMode[index] = false;
    const updatedName = this.videoRecords[index].recorderName || ''; // Get the updated name and  '' use for unnamed;
    this.videoService.updateRecorderName(index, updatedName); // Update the name in the service
  }

  DeleteScreenRecord(index: number) {
    this.videoRecords.splice(index, 1)

  }


  // Toggle between pause and resume
  toggleRecord() {
    if (this.isPaused) {
      this.ReusumeRecord();
    } else {
      this.PauseRecord();
    }
    this.isPaused = !this.isPaused; // Toggle the state
  }

  // Pause the recording
  PauseRecord() {

    this.videoService.PauseRecording(true)

  }

  // Resume the recording
  ReusumeRecord() {
    this.videoService.ResumeRecording(true)

  }
  // Function to convert Blob URL to Blob object
  async convertBlobUrlToBlob(blobUrl: string): Promise<Blob> {
    const response = await fetch(blobUrl); // Fetch the Blob from the Blob URL
    const blob = await response.blob();   // Get the actual Blob object from the response
    return blob; // Return the Blob object
  }

  async SaveBackupScreenrecord(index: number) {
    const bloburl = this.videoRecords[index];
    const videoBlob = await this.convertBlobUrlToBlob(bloburl.url);
    const formData = new FormData();
    formData.append('bucket', 'ProteanStorageVideo'); // Add the Blob as a file
    formData.append('filePath', this.currentUser.email + '/' + Date.now().toString() + '.webm');
    formData.append('file', videoBlob, 'recorded-video.webm'); // Add the Blob as a file
    const response = await this.videoService.uploadVideo(formData, this.currentUser.email)

    if (response.status == "200" || response.status == 200 || response.success == "true" || response.success == true)
    this.isBackupDisabled[index] = true;

    this.openAlertMod(this.alerttemplate, "Video uploaded Save As backup");

  }

  downloadVideo(videoUrl: any, index: number) {
    const filename = `${this.device.serial}${index + 1}.webm`;

    fetch(videoUrl)
      .then(response => response.blob())
      .then(blob => {
        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob);

        // Create temporary link element
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Release the blob URL
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Error downloading video:', error);
      });

  }

  downloadAllBackup() {
    this.modalRef = this.dialog.open(this.downloadAllBackupVidio)

  }
  downloadAllVideo() {

    this.newArray.forEach(url => {
      const filename = `${this.device.serial}.webm`;

      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          // Create a temporary URL for the blob
          const url = window.URL.createObjectURL(blob);

          // Create temporary link element
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Release the blob URL
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.error('Error downloading video:', error);
        });

      this.cancelRequest()
    })

  }




  ngOnDestroy(): void {
    this.videoRecords=[]
    this.videoService.clearVideoRecords();

    if (this.videoSubscription) {
      this.videoSubscription.unsubscribe();
    }
  }
}




